/**
* @fileOverview queue.component.ts - Contains handling of queue management
* @author Jan Valentik
*/
//import IAngularEvent = angular.IAngularEvent;
var QueueSetasideController = (function () {
    function QueueSetasideController($scope, env, $filter, $timeout, $q, socket, DTS, DTOptionsBuilder, DTColumnBuilder, _, $compile, $state, $stateParams, notify, Dialog, settings, $mdDialog) {
        var _this = this;
        this.$scope = $scope;
        this.env = env;
        this.$filter = $filter;
        this.$timeout = $timeout;
        this.$q = $q;
        this.socket = socket;
        this.DTS = DTS;
        this.DTOptionsBuilder = DTOptionsBuilder;
        this.DTColumnBuilder = DTColumnBuilder;
        this._ = _;
        this.$compile = $compile;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.notify = notify;
        this.Dialog = Dialog;
        this.settings = settings;
        this.$mdDialog = $mdDialog;
        this.items = [];
        this.processing = true;
        this.waitForReport = false;
        this.oncePressed = false;
        this.dtInstance = {};
        socket.forward('queue.setaside.setPaid', $scope);
        this.$scope.$on('socket:queue.setaside.setPaid', function (event, data) {
            _this.dtInstance.DataTable.ajax.reload(null, false);
            if (data.error) {
                return _this.notify.error(data.error);
            }
            else {
                return _this.notify.success('Updated successfully.');
            }
        });
        socket.forward('queue.setaside.get-report', $scope);
        this.$scope.$on('socket:queue.setaside.get-report', function (event, data) {
            _this.waitForReport = false;
            if (!data.payload.error) {
                var a = document.createElement('A');
                document.body.appendChild(a);
                a.setAttribute('style', 'display: none;');
                var url = window.URL.createObjectURL(new Blob([decodeURIComponent(data.payload)], { type: 'text/plain;charset=utf-8' })); //'\ufeff',
                a.setAttribute('href', url);
                var d = new Date().toDateString();
                a.setAttribute('download', "DMT-Set-Aside-Report_" + d + ".txt");
                a.click();
            }
        });
    }
    QueueSetasideController.prototype.$onInit = function () {
        var _this = this;
        this.queueLabel = 'Set Aside Queue';
        var that = this;
        /*        this.socket.emit('module', {
                    module: {
                        application: 'dmt',
                        function: 'getAllErroredQueues',
                        script: 'queue/queue',
                        email: this.env.user.email,
                    }
                });
        */
        this.dtColumns = this.buildColumns();
        this.dtOptions = this.DTOptionsBuilder.newOptions()
            .withOption('ajax', {
            dataSrc: function (data) {
                _this.items = data.data;
                return data.data;
            },
            url: '/api/queue/setaside',
            type: 'POST',
            beforeSend: function (request) {
                _this.processing = true;
                request.setRequestHeader('Authorization', 'Bearer ' + that.env.user.token);
            },
            data: {}
        })
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('searchDelay', 1000)
            .withPaginationType('full_numbers')
            .withOption('createdRow', createdRow)
            .withOption('drawCallback', function (settings) {
            _this.processing = false;
        });
        function createdRow(row, data, dataIndex) {
            var thresholdDate = new Date();
            thresholdDate.setHours(0, 0, 0, 0);
            var finDate = 0;
            for (var _i = 0, _a = data.doc.docs; _i < _a.length; _i++) {
                var oneDoc = _a[_i];
                if (oneDoc.paymentDate > finDate) {
                    finDate = oneDoc.paymentDate;
                }
            }
            var createdOn = new Date(parseInt(finDate, 10));
            createdOn.setHours(0, 0, 0, 0);
            if (createdOn <= thresholdDate) {
                $(row).addClass('tblRow').css('color', 'red');
            }
            else {
                $(row).addClass('tblRow');
            }
            var el = angular.element;
            that.$compile(el(row).contents())(that.$scope);
        }
    };
    QueueSetasideController.prototype.buildColumns = function () {
        var _this = this;
        var that = this;
        return [this.DTColumnBuilder.newColumn('doc.ceid')
                .withTitle('CEID')
                .notSortable()
                .withOption('searchable', true),
            this.DTColumnBuilder.newColumn('doc.bpName')
                .withTitle('BP Name')
                .notSortable()
                .withOption('searchable', true),
            this.DTColumnBuilder.newColumn('doc.bpCountry')
                .withTitle('BP Country')
                .notSortable()
                .withOption('searchable', true),
            this.DTColumnBuilder.newColumn('doc.docCountry')
                .withTitle('Opportunity Country')
                .notSortable()
                .withOption('searchable', true),
            this.DTColumnBuilder.newColumn(null)
                .withTitle('Payment Date / Frequency')
                .withOption('searchable', true)
                .renderWith(function (data, type, full, meta) {
                var finDate = 0;
                var finFreq = [];
                for (var _i = 0, _a = full.doc.docs; _i < _a.length; _i++) {
                    var oneDoc = _a[_i];
                    if (oneDoc.paymentDate > finDate) {
                        finDate = oneDoc.paymentDate;
                    }
                    if (finFreq.indexOf(oneDoc.payfreq) < 0) {
                        finFreq.push(oneDoc.payfreq);
                    }
                }
                finFreq.sort();
                //let roundedDate = Math.round(parseInt(finDate, 13) / 1000);
                //console.log(roundedDate);
                return _this.$filter('date')(new Date(Math.round(finDate / 1000) * 1000), 'fullDate', 'UTC') + " / " + (finFreq.length > 0 ? finFreq.join(', ') : 'Unknown');
            })
                .notSortable(),
            this.DTColumnBuilder.newColumn(null)
                .withTitle('Bonus Amount')
                .renderWith(function (data, type, full, meta) {
                return full.doc.amount + " " + full.doc.currency;
            })
                .notSortable(),
            this.DTColumnBuilder.newColumn('doc.docs.length')
                .withTitle('Documents')
                .notSortable(),
            this.DTColumnBuilder.newColumn('doc.invsRequested')
                .withTitle('Requested')
                .notSortable(),
            this.DTColumnBuilder.newColumn('doc.invsReceived')
                .withTitle('Received')
                .notSortable(),
            this.DTColumnBuilder.newColumn(null)
                .withTitle('')
                .notSortable()
                .renderWith(this.buttonDetails)
                .withOption('className', 'details-control'),
            this.DTColumnBuilder.newColumn(null)
                .withTitle('')
                .notSortable()
                .renderWith(this.buttonPaid)
                .withOption('className', 'details-control'),
        ];
    };
    QueueSetasideController.prototype.buttonDetails = function (data, type, full, meta) {
        return "<md-button class=\"md-raised md-primary\" ng-click=\"vm.getDetails('" + meta.row + "')\" ng-disabled=\"vm.processing\">Details</md-button>";
    };
    QueueSetasideController.prototype.buttonPaid = function (data, type, full, meta) {
        return "<md-button class=\"md-raised md-primary\" ng-click=\"vm.setPaid('" + meta.row + "')\" ng-disabled=\"vm.processing\">Paid</md-button>";
    };
    QueueSetasideController.prototype.setPaid = function (rowId) {
        var _this = this;
        if (this.processing) {
            return;
        }
        // const oneItem = JSON.parse(rowId);
        var items = {
            docs: this.items[rowId].doc.docs.map(function (doc) {
                if (doc.invoice_flags && doc.invoice_flags.requested && doc.invoice_flags.received) {
                    return {
                        doc: doc.id,
                        value: true
                    };
                }
            })
                .filter(function (item) {
                return item !== undefined;
            })
        };
        if (items.docs.length === 0) {
            var items_1 = {
                icon: 'ERROR',
                message: 'No documents with invoice received flag.',
                title: 'Error'
            };
            this.Dialog.updateValidForm(undefined, items_1, 'confirm-prompt.html').then(function (dResult) { return; });
            return;
        }
        this.Dialog.updateValidForm(undefined, items, 'setAside-documents_select.html').then(function (dResult) {
            _this.processing = true;
            var docs = [];
            dResult.docs.forEach(function (doc) {
                if (doc.value === true) {
                    docs.push(doc.doc);
                }
            });
            _this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    function: 'setPaid',
                    data: {
                        docs: docs,
                        item: _this.items[rowId].doc
                    },
                    script: 'detail/payment/v1/payment',
                    email: _this.env.user.email,
                    token: _this.env.user.token
                }
            });
        });
    };
    QueueSetasideController.prototype.viewRecord = function (doc_id) {
        this.$state.go('detail.payment', {
            id: doc_id.substring(4)
        });
    };
    QueueSetasideController.prototype.getDetails = function (rowId) {
        var _this = this;
        if (this.processing) {
            return;
        }
        console.log(rowId);
        //const oneItem = JSON.parse(rowId);
        var items = {
            item: this.items[rowId],
            select: function (index) {
                _this.Dialog.$mdDialog.cancel();
                _this.viewRecord(_this.items[rowId].doc.docs[index].id); //this.items[rowId].docs[index].id);
            }
        };
        if (items.item.doc.docs.length === 0) {
            var items_2 = {
                icon: 'ERROR',
                message: 'No documents in this bucket.',
                title: 'Error'
            };
            this.Dialog.updateValidForm(undefined, items_2, 'confirm-prompt.html').then(function (dResult) { return; });
            return;
        }
        this.Dialog.updateValidForm(undefined, items, 'setAside-details.html').then(function (dResult) {
            return;
        });
    };
    QueueSetasideController.$inject = [
        '$scope', 'env', '$filter', '$timeout', '$q', 'socket',
        'DTS', 'DTOptionsBuilder', 'DTColumnBuilder', '_',
        '$compile', '$state', '$stateParams', 'notify', 'Dialog', 'settings', '$mdDialog'
    ];
    return QueueSetasideController;
}());
var QueueSetasideComponent = (function () {
    function QueueSetasideComponent() {
        this.templateUrl = 'queueSetaside.html';
        this.controllerAs = 'vm';
        this.controller = QueueSetasideController;
    }
    return QueueSetasideComponent;
}());
angular
    .module('application')
    .component('queueSetasideSection', new QueueSetasideComponent());

//# sourceMappingURL=queue.setaside.component.js.map
